import { useInteractiveTableActions } from "PFComponents/table/interactive/interactive_table_store_context";

import { useOnRoleListShift } from "./use_on_role_list_shift";

type ClearSelectionOnRoleListShiftProps = {
  roleListKeys: (string | number)[];
};

export const ClearSelectionOnRoleListShift = ({ roleListKeys }: ClearSelectionOnRoleListShiftProps) => {
  const { clearSelection } = useInteractiveTableActions();

  useOnRoleListShift(roleListKeys, clearSelection);

  return null;
};
